import UploadImages from './UploadImages';

export default UploadImages;
